import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

function ProductionDetails() {
 
 const baseUrl = process.env.baseUrl;
   const [formData, setFormData] = useState({
    rawMaterials: "",
    finalProducts: "",
    technologyUsed: "",
    productionCapacity: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.rawMaterials.trim()) newErrors.rawMaterials = "Raw materials are required";
    if (!formData.finalProducts.trim()) newErrors.finalProducts = "Final products are required";
    if (!formData.technologyUsed.trim()) newErrors.technologyUsed = "Technology is required";
    if (!formData.productionCapacity.trim()) newErrors.productionCapacity = "Capacity is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.post("/api/production-details", formData);
      navigate("/certifications"); // Navigate to next step
    } catch (err) {
      console.error("Submission failed", err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">Production Details</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="rawMaterials"
                    value={formData.rawMaterials}
                    onChange={handleChange}
                    className={`form-control ${errors.rawMaterials ? "is-invalid" : ""}`}
                    placeholder="Main Raw Materials Used"
                  />
                  {errors.rawMaterials && (
                    <div className="invalid-feedback">{errors.rawMaterials}</div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="finalProducts"
                    value={formData.finalProducts}
                    onChange={handleChange}
                    className={`form-control ${errors.finalProducts ? "is-invalid" : ""}`}
                    placeholder="Final Products"
                  />
                  {errors.finalProducts && (
                    <div className="invalid-feedback">{errors.finalProducts}</div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="technologyUsed"
                    value={formData.technologyUsed}
                    onChange={handleChange}
                    className={`form-control ${errors.technologyUsed ? "is-invalid" : ""}`}
                    placeholder="Manufacturing Technology Used"
                  />
                  {errors.technologyUsed && (
                    <div className="invalid-feedback">{errors.technologyUsed}</div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="productionCapacity"
                    value={formData.productionCapacity}
                    onChange={handleChange}
                    className={`form-control ${errors.productionCapacity ? "is-invalid" : ""}`}
                    placeholder="Production Capacity"
                  />
                  {errors.productionCapacity && (
                    <div className="invalid-feedback">{errors.productionCapacity}</div>
                  )}
                </div>
              </div>

              <button type="submit" className="btn btn-custom w-100">
                Continue →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductionDetails;
